
// import { EnvironmentTypesComponent } from './environmentTypes/environmentTypes';
import { SettingComponent } from './settings-ang7/settings';
import { EnvironmentTypes } from './environmentTypes-ang7/environmentTypes'
// import { AssignSchemasComponent } from './assignSchemas/assignSchemas';
// import { SchemasEnvTypeComponent } from './assignSchemas/envTypeBox/envType';
// import { SchemasEnvironmentComponent } from './assignSchemas/envTypeBox/environment/environment';
// import { EnvTypeRotateComponent } from './assignSchemas/environmentTypeRotator/environmentTypeRotator';
import { EnvTypeRotateItemComponent } from './assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotatorItem';
//import { RotateSchemasRepositoryComponent } from './assignSchemas/environmentTypeRotator/rotatorItem/rotatorSchemasRepository/rotatorSchemasRepository';
import  { RotateSchemasRepositoryComponent } from './assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotate-schemas-repository/rotate-schemas-repository.component'
import { AssignSchemasComponent } from './assignSchemas-ang7/assignSchemas'; 
// import { EnvTypeRotateComponent } from './assignSchemas-ang7/environmentTypeRotator/environmentTypeRotator'
// import { SchemaConnectorComponent } from './assignSchemas/environmentTypeRotator/schemaConnector/schemaConnector';
import {downgradeComponent} from "@angular/upgrade/static";
import {SchemaItemComponent} from "@app/authorized/projectWizard/schema-item/schema-item.component";
import {EnvironmentsRotatorComponent} from "./assignSchemas-ang7/environmentTypeRotator/rotatorItem/environmentsRotator/environmentsRotator";
import {SchemaConnectorComponent} from "@app/authorized/projectWizard/schema-connector/schema-connector.component";
//import {schemRepos}
// import {RotateSchemasRepositoryComponent} from "@app/authorized/projectWizard/rotate-schemas-repository/rotate-schemas-repository.component";

export default angular.module('projectWizard', [])
   // .component('projectWizard', ProjectWizardComponent)
    // .component('settings', ProjectSettingsComponent)
    // .component('envTypes', EnvironmentTypesComponent)
   //  .component('assignSchemas', AssignSchemasComponent)
    // .component('schemasEnvType', SchemasEnvTypeComponent)
    // .component('schemasEnv', SchemasEnvironmentComponent)
    
   //  .component('schemasEnvTypeRotate', EnvTypeRotateComponent)
   // .component('schemasEnvTypeRotateItem', EnvTypeRotateItemComponent)
                
   // .component('environmentsRotator', EnvironmentsRotatorComponent)

    // .component('schemaItem', SchemaItemComponent)
    // .component('environmentItem', EnvironmentItemComponent)
    // .component('environmentsSchemas', EnvironmentSchemasComponent)
    // .component('schemaConnector', SchemaConnectorComponent)
    // .component('schemasRepository', RotateSchemasRepositoryComponent)
    // .directive('environmentItem', downgradeComponent({ component: EnvironmentItemComponent }))

    // .directive('schemasRepository', downgradeComponent({ component: RotateSchemasRepositoryComponent }))
    
    .directive('schemasRepository', downgradeComponent({ component: RotateSchemasRepositoryComponent }))
    .directive('environmentsRotator', downgradeComponent({ component: EnvironmentsRotatorComponent }))
    .directive('schemasEnvTypeRotateItem', downgradeComponent({ component: EnvTypeRotateItemComponent }))
   //  .directive('schemasEnvTypeRotate', downgradeComponent({ component: EnvTypeRotateComponent }))
    .directive('environmentTypes', downgradeComponent({ component: EnvironmentTypes }))
    .directive('settings', downgradeComponent({ component: SettingComponent }))
    .directive('assignSchemas', downgradeComponent({ component: AssignSchemasComponent }))
    .directive('schemaConnector', downgradeComponent({ component: SchemaConnectorComponent }))
    .directive('schemaItem', downgradeComponent({ component: SchemaItemComponent }));



// WEBPACK FOOTER //
// ./src/app/authorized/projectWizard/index.js